import { Chip } from '@ds';
import { ConditionalRender } from '@ui';
import { OutcomeData, TurndownRecord } from '@/api/apis/case';
import {
  outcomeTypeNames,
  dispositionSpecificationNames,
  turndownOutcomeNames,
  dryRunReasonNames,
} from '@/constants/case/case.constants';
import { formatDate } from '@/utils/helpers';
import SectionRow from '../SectionRow';

type OutcomeFieldsProps = {
  oneLungTurndown?: TurndownRecord;
  outcomeData?: OutcomeData;
};

export const OutcomeFields = ({ oneLungTurndown, outcomeData }: OutcomeFieldsProps) => {
  const oneLungItem = oneLungTurndown?.item;

  if (oneLungItem) {
    return (
      <>
        <SectionRow label="Time of event">
          {formatDate(oneLungItem.timestamp, 'MM/dd/yyyy HH:mm zzz', { timezone: oneLungItem.timeZone })}
        </SectionRow>
        <SectionRow label="Lung">
          <Chip size="sm">{oneLungItem.lung}</Chip>
        </SectionRow>
        <SectionRow label="Lung cancellation reason">
          {dryRunReasonNames[oneLungItem.dispositionReason!] || oneLungItem.dispositionReason}
        </SectionRow>
        <SectionRow label="Specification">
          {dispositionSpecificationNames[oneLungItem.dispositionSpecification!] || oneLungItem.dispositionSpecification}
        </SectionRow>
        <SectionRow label="One lung turndown outcome">
          <Chip size="sm">{turndownOutcomeNames[oneLungItem.turndownOutcome!] || oneLungItem.turndownOutcome}</Chip>
        </SectionRow>
        <ConditionalRender show={!!oneLungItem.details}>
          <SectionRow label="Additional Comments" truncate={false}>
            {oneLungItem.details}
          </SectionRow>
        </ConditionalRender>
      </>
    );
  }
  if (outcomeData) {
    return (
      <>
        <SectionRow label="Outcome">
          <Chip size="sm">{outcomeTypeNames[outcomeData.outcomeType]}</Chip>
        </SectionRow>
        <SectionRow label="Reason">
          {dryRunReasonNames[outcomeData.dispositionReason] || outcomeData.dispositionReason}
        </SectionRow>
        <SectionRow label="Specification">
          {dispositionSpecificationNames[outcomeData.dispositionSpecification] || outcomeData.dispositionSpecification}
        </SectionRow>
        <ConditionalRender show={!!outcomeData.turndownOutcome}>
          <SectionRow label="Turndown Outcome">
            <Chip size="sm">{turndownOutcomeNames[outcomeData.turndownOutcome!] || outcomeData.turndownOutcome}</Chip>
          </SectionRow>
        </ConditionalRender>
        <ConditionalRender show={!!outcomeData?.dispositionComment}>
          <SectionRow label="Additional Comments" truncate={false}>
            {outcomeData.dispositionComment}
          </SectionRow>
        </ConditionalRender>
      </>
    );
  }
  return null;
};
